var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          attrs: {
            color: "primary",
            flat: "",
            disabled: _vm.disabled,
            icon: ""
          },
          on: { click: _vm.setupCamera }
        },
        [_c("v-icon", [_vm._v("add_a_photo")])],
        1
      ),
      _vm._v(" "),
      _vm.isShowPhotoPopup
        ? _c("SimpleTextPopup", {
            ref: "simpleTextPopup",
            attrs: {
              rightMethod: _vm.capturePhoto,
              rightButtonText: "Take photo",
              medium: ""
            },
            on: {
              popupClose: function() {
                return (this$1.isShowPhotoPopup = false)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("v-layout", { attrs: { "justify-center": "" } }, [
                        _c("video", {
                          ref: "video",
                          attrs: { width: "80%", autoplay: "" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("canvas", {
                        ref: "canvas",
                        staticStyle: { display: "none" }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              415886928
            ),
            model: {
              value: _vm.isShowPhotoPopup,
              callback: function($$v) {
                _vm.isShowPhotoPopup = $$v
              },
              expression: "isShowPhotoPopup"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-558cd49a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-558cd49a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CameraUploadWidget.vue
// module id = null
// module chunks = 